import * as React from "react";
import { sendEmail } from "../services/emailService";
import { formEmailPayload } from "../config";

export default async function sendMail(values: any) {
  let payload = formEmailPayload(values);
  let result = await sendEmail(payload);
  return result;
}
